import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useHasUserGroups } from '#app/hooks/useHasUserGroups.js';
import { useHasWorkspaceMemberFeature } from '#app/hooks/useHasWorkspaceMemberFeature.js';

type UseOrganizationMembershipReturn = {
  belongsToOrganization: boolean;
  canInviteOrganizationMembers: boolean;
  canInviteWorkspaceMemberWithAdminRole: boolean;
  isC4CSubscriber: boolean;
  organizationHasMultipleMembers: boolean;
};

export const useOrganizationMembership =
  (): UseOrganizationMembershipReturn => {
    const currentUser = useCurrentUser();

    const isC4CSubscriber = useHasUserGroups('CONTRA_FOR_COMPANIES_CLIENT');

    const canInviteWorkspaceMemberWithMemberRole = useHasWorkspaceMemberFeature(
      'INVITE_MEMBER_WITH_ROLE_MEMBER_FOR_WORKSPACE',
    );

    const canInviteWorkspaceMemberWithAdminRole = useHasWorkspaceMemberFeature(
      'INVITE_MEMBER_WITH_ROLE_ADMIN_FOR_WORKSPACE',
    );

    const canInviteOrganizationMembers =
      canInviteWorkspaceMemberWithMemberRole ||
      canInviteWorkspaceMemberWithAdminRole;

    if (!currentUser?.profile.organizationV2) {
      return {
        belongsToOrganization: false,
        canInviteOrganizationMembers,
        canInviteWorkspaceMemberWithAdminRole: false,
        isC4CSubscriber: false,
        organizationHasMultipleMembers: false,
      };
    }

    return {
      belongsToOrganization: true,
      canInviteOrganizationMembers,
      canInviteWorkspaceMemberWithAdminRole,
      isC4CSubscriber,
      organizationHasMultipleMembers:
        currentUser.workspaceForSelectedUserType.members.count > 1,
    };
  };
